var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._t("default", null, null, {
    click: _vm.click
  }), _c('v-file-input', {
    ref: "file-input",
    staticClass: "d-none",
    on: {
      "change": function change(file) {
        return _vm.upload(file);
      }
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }